/**
 * @enum CompassFlags
 * Enumerates compass directions.
 * @note Useful for tracking a direction, e.g. when dragging.
 * @flag
 */
export enum CompassFlags {
    None = 0 << 0,  //INFO[MW]: This value exists as a means to define a directionless value and eliminate TypeScript errors
    Up = 1 << 0,
    Right = 1 << 1,
    Down = 1 << 2,
    Left = 1 << 3,
    UpRight = CompassFlags.Up | CompassFlags.Right,
    DownRight = CompassFlags.Down | CompassFlags.Right,
    DownLeft = CompassFlags.Down | CompassFlags.Left,
    UpLeft = CompassFlags.Up | CompassFlags.Left,
    Horizontal = CompassFlags.Left | CompassFlags.Right,
    Vertical = CompassFlags.Up | CompassFlags.Down
}
